<template>
  <div class="pb-3" >
    <va-card :title="'Meu Perfil'">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Nome" v-slot="{ errors }">
                <va-input
                  v-model="user.name"
                  :label="$t('users.forms.nameLabel')"
                  :placeholder="$t('users.forms.namePlaceholder')"
                  :success="errors.length == 0 && user.name.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required|email" name="Email" v-slot="{ errors }">
                <va-input
                  type='email'
                  v-model="user.email"
                  :label="$t('users.forms.emailLabel')"
                  :placeholder="$t('users.forms.emailPlaceholder')"
                  :success="errors.length == 0 && user.email.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="min:6|confirmed:user.confirmPassword" name="Senha" v-slot="{ errors }">
                <va-input
                  v-model="user.password"
                  type="password"
                  :label="$t('users.forms.passwordLabel')"
                  :placeholder="$t('users.forms.passwordPlaceholder')"
                  :success="errors.length == 0 && user.password.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider vid="user.confirmPassword" name="Confirme a Senha">
                <va-input
                  v-model="user.confirmPassword"
                  type="password"
                  :label="$t('users.forms.confirmPasswordLabel')"
                  :placeholder="$t('users.forms.confirmPasswordPlaceholder')"
                  :success="user.confirmPassword.length > 0"
                />
              </ValidationProvider>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
export default {
  name: 'MyPerfil',
  data () {
    return {
      user: {
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
      },
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  mounted () {
    const userLog = this.$store.getters['authenticate/user']
    this.user.name = userLog.name
    this.user.email = userLog.email
    this.user.password = ''
    this.user.confirmPassword = ''
  },
  methods: {
    submit () {
      this.onUpdate()
    },
    launchToast (text, icon, onComplete = null) {
      this.showToast(
        text,
        {
          icon: icon,
          position: 'top-right',
          duration: 1000,
          fullWidth: false,
          onComplete: onComplete,
        },
      )
    },
    onUpdate () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      // eslint-disable-next-line camelcase
      const { name, email, password, confirmPassword } = this.user
      const self = this
      this.$axios.put(
        '/api/user/update',
        password.length !== 0
          ? {
            name,
            email,
            password,
            confirmPassword,
          }
          : {
            name,
            email,
          },
      )
        .then(response => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          const { dispatch } = self.$store
          dispatch('authenticate/updateUser', { name, email })
          self.launchToast(
            self.$t('auth.sucess_login'),
            'fa-check',
            () => {
              if (self.$store.getters['authenticate/user'].role === 'external') {
                self.$router.push({ name: 'posts' })
              } else if (self.$store.getters['authenticate/user'].role === 'partner') {
                self.$router.push({ name: 'partners' })
              } else {
                self.$router.push({ name: 'dashboard' })
              }
            },
          )
        })
        .catch(e => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.showToast(
            self.$t('toasts.errorUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">

</style>
